import ScrollReveal from "@/components/feature/ScrollReveal";
import { whySando, whyVideoPoster } from "@/mocks/menu";
import { SANDO_CRAFT_VIDEO } from "@/mocks/site";
import { getYouTubeEmbedUrl } from "@/utils/media";

export default function WhySando() {
  const craftEmbedUrl = getYouTubeEmbedUrl(SANDO_CRAFT_VIDEO);

  return (
    <section id="por-que" className="w-full bg-background-100 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-accent-500">
            La diferencia
          </p>
          <h2 className="mt-4 font-heading text-4xl leading-[1.05] text-foreground-950 md:text-6xl">
            No es un sándwich cualquiera
          </h2>
        </ScrollReveal>

        <ScrollReveal className="mt-12 md:mt-16">
          <figure className="w-full">
            <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-secondary-300 bg-foreground-950">
              {craftEmbedUrl ? (
                <iframe
                  className="absolute inset-0 h-full w-full"
                  src={craftEmbedUrl}
                  title="Video de la preparación de los sandos de Sando by Cerón"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                />
              ) : SANDO_CRAFT_VIDEO ? (
                <video
                  className="h-full w-full object-cover"
                  src={SANDO_CRAFT_VIDEO}
                  poster={whyVideoPoster}
                  controls
                  playsInline
                  preload="metadata"
                  aria-label="Video de la preparación de los sandos de Sando by Cerón"
                />
              ) : (
                <>
                  <img
                    src={whyVideoPoster}
                    alt="Chef cortando un sando de autor sobre pan de leche"
                    className="h-full w-full object-cover object-top opacity-80"
                  />
                  <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-3 bg-foreground-950/30">
                    <span className="flex h-16 w-16 items-center justify-center rounded-full border border-background-50/70 bg-background-50/10 text-background-50 backdrop-blur-sm md:h-20 md:w-20">
                      <i className="ri-play-fill text-3xl md:text-4xl" aria-hidden="true" />
                    </span>
                    <span className="px-6 text-center text-xs font-medium uppercase tracking-[0.3em] text-background-50 md:text-sm">
                      Espacio para video
                    </span>
                  </div>
                </>
              )}
            </div>
            <figcaption className="mt-4 text-sm leading-relaxed text-foreground-600">
              Así se arma cada sando: pan de leche recién horneado, producto de granja y
              sazón de autor, pieza por pieza.
            </figcaption>
          </figure>
        </ScrollReveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-4 md:gap-8">
          {whySando.map((item, index) => (
            <ScrollReveal key={item.id} delay={index * 80}>
              <div className="flex h-full flex-col border-t border-secondary-300 pt-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-heading text-xl text-foreground-950 md:text-2xl">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}